import { render, staticRenderFns } from "./global-notice.vue?vue&type=template&id=f095c072"
import script from "./global-notice.vue?vue&type=script&lang=js"
export * from "./global-notice.vue?vue&type=script&lang=js"
import style0 from "./global-notice.vue?vue&type=style&index=0&id=f095c072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports